import { functions } from '@/firebase/init'

export default {
	namespaced: true,
	state: {
		tickets: [],
		loaded: false
	},
	getters: {
		loaded(state) {
			return state.loaded
		},
		tickets(state) {
			return state.tickets
		},
		latestTickets(state) {
			const latestTickets = state.tickets.filter((ticket, index) => {
				return index < 3 // fetching latest 3 support tickets
			})
			return latestTickets
		}
	},
	mutations: {
		loadedMutate(state, payload) {
			state.loaded = payload.state
		},
		ticketsMutate(state, payload) {
			state.tickets = [
				...payload.supportTickets
			]
		}
	},
	actions: {
		fetchTickets(context) {
			// Set loaded to false
			context.commit('loadedMutate', { state: false })

			const fetchClientSupportTickets = functions.httpsCallable(
        "fetchClientSupportTickets"
      );
			fetchClientSupportTickets({ clientID: context.rootGetters.getCustomerID })
			.then(response => {
				context.commit('ticketsMutate', response.data)

				// Set loaded to true
				context.commit('loadedMutate', { state: true })
			})
			.catch(() => {
				context.commit('loadedMutate', { state: true });
				// Show error message for 5 sec
				// context.dispatch('alert/update', {
				// 	type: "danger",
				// 	message: err.message,
				// 	show: true
				// }, { root: true });

				setTimeout(() => {
					context.dispatch('alert/showUpdate', { show: false }, { root: true })
				}, 5000)
			})
		}
	}
}
